import OpportunityStatus from '@/constants/OpportunityStatus';
import type OpportunitiesFilterParams from '../types/OpportunitiesFilterParams';

export default function mapQueryToFilter(
  query: Omit<OpportunitiesFilterParams, 'archived'> & {
    archived?: OpportunityStatus | boolean;
    labelIds?: string[];
  },
) {
  const { archived, labelIds, ...rest } = query;

  const newQuery: Record<string, unknown> = rest;

  // This function is used by the OpportunitiesDataList in a couple different
  // context. `archived` can be either an OpportunityStatus when used on the
  // Opportunity list view, or it is a boolean when used in reports.
  switch (archived) {
    case OpportunityStatus.ACTIVE:
    case false:
      newQuery.archived = false;
      break;
    case OpportunityStatus.ARCHIVED:
      newQuery.archived = true;
      break;
    case true:
    default:
      break;
  }

  // `labelIds` are used in the Opportunity Report, but need to be converted to
  // `opportunityLabelIds` when used for any opportunity list view.
  if (labelIds) {
    newQuery.opportunityLabelIds = labelIds;
  }

  return newQuery;
}
